<template>
  <div class="recommendations-page" v-if="!showEmptyState">
    <div class="back-section">
      <router-link :to="'/favorites'" class="flex align-center back-link">
        <inline-svg width="40" height="40" :src="require('@/assets/img/icons/chevron_left.svg')" />
        <h4>ALL FAVORITES</h4>
      </router-link>
    </div>

    <h1 class="medium-page-title">Products You Saved</h1>
    <div class="page-content">
      <div class="controls-section">
        <search-input-field
          v-model="searchValue"
          class="search-input"
          :placeholder="isMobile ? 'Search products' : 'Search'"
        />
        <sorting-options
          :options="sortingOptions"
          :is-mobile="isMobile"
          :hide-label="isMobile"
          no-pagination
          no-tracking
        />
      </div>

      <product-tiles
        class="product-tiles"
        :loading="favoriteProductsLoading"
        :products="filteredFavoriteProducts"
        four-column
      />
    </div>
  </div>

  <favorite-products-empty-state v-else />
</template>

<style scoped lang="scss" src="../favoritesSubPage.scss" />

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";
</style>

<script>
import { favoritesPageHelper } from "../../favoritesPageHelper";
import FavoriteBrandTile from "../../favoriteBrandTile";
import InlineSvg from "vue-inline-svg";
import _debounce from "lodash/debounce";
import FavoriteProductsEmptyState from "./../../emptyStates/favoriteProductsEmptyState.vue";

export default {
  mixins: [favoritesPageHelper],
  components: {
    FavoriteBrandTile,
    FavoriteProductsEmptyState,
    InlineSvg,
  },
  data() {
    return {
      searchValue: this.$route.query.keyword || "",
      brands: [],
      sortingOptions: [
        {
          name: "Most Recently Saved",
          value: "most_recently_saved",
        },
        {
          name: "High Sell Through",
          value: "total_orders",
          direction: "DESC",
        },
        {
          name: "New Arrivals",
          value: "created_at",
          direction: "DESC",
        },

        {
          name: "Price: Low to High",
          value: "wholesale_price_asc",
          direction: "ASC",
        },
        {
          name: "Price: High to Low",
          value: "wholesale_price_desc",
          direction: "DESC",
        },
      ],
    };
  },
  beforeMount() {
    this.getFavoriteProducts();
    this.setDefaultSorting();
  },
  computed: {
    sortBy() {
      return this.sortingOptions.find((item) => item.value === this.$route.query.sortBy);
    },
    searchKeyword() {
      return this.$route.query.keyword;
    },
    showEmptyState() {
      return !this.favoriteProductsLoading && !this.favoriteProductObjects?.length;
    },
    filteredFavoriteProducts() {
      const favoriteProducts = [...this.favoriteProducts];

      return this.sortProducts(this.filterProductsByKeyword(favoriteProducts));
    },
  },
  methods: { filterProductsByKeyword, sortProducts },
  watch: {
    searchValue: _debounce(function (value) {
      this.updateURLParams("keyword", value);
    }, 150),
  },
};

function sortProducts(products) {
  let sortDataKey = this.sortBy?.value;

  if (sortDataKey === "most_recently_saved") {
    return products;
  }

  if (sortDataKey === "wholesale_price_asc") {
    sortDataKey = "wholesale_price";
  }
  if (sortDataKey === "wholesale_price_desc") {
    sortDataKey = "wholesale_price";
  }

  const sortDirection = this.sortBy?.direction;

  const sortedProducts = products.sort((aProduct, bProduct) => {
    return sortDataKey === "created_at"
      ? new Date(bProduct[sortDataKey]) - new Date(aProduct[sortDataKey])
      : bProduct[sortDataKey] - aProduct[sortDataKey];
  });

  return sortDirection === "ASC" ? sortedProducts?.reverse() : sortedProducts;
}

function filterProductsByKeyword(products) {
  return products?.filter((product) =>
    this.searchKeyword ? product.name?.toLowerCase().includes(this.searchKeyword?.toLowerCase()) : true
  );
}
</script>
